import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this is where you'd handle the form data (e.g., send to backend or email service)
    alert("Thanks for your message!");
    setFormData({ name: "", phone: "", email: "", message: "" });
  };

  return (
    <section style={{ padding: "4rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "2.5rem", textAlign: "center", marginBottom: "1.5rem" }}>
        Get in Touch
      </h1>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          required
          style={{ ...inputStyle, resize: "vertical" }}
        />

        <button
          type="submit"
          style={{
            backgroundColor: "black",
            color: "white",
            padding: "0.9rem",
            border: "none",
            fontWeight: "bold",
            fontSize: "1rem",
            cursor: "pointer",
            borderRadius: "6px",
            transition: "background 0.2s",
          }}
        >
          Send
        </button>
      </form>
    </section>
  );
}

const inputStyle = {
  padding: "0.75rem 1rem",
  fontSize: "1rem",
  borderRadius: "6px",
  border: "1px solid #ccc",
  outline: "none",
};

export default Contact;